import React, { Component } from 'react';
import { connect } from 'react-redux'
import NavBar from 'common/nav-bar'
import { fetchLanguage } from 'redux/actions/app'
import { Route, withRouter} from "react-router-dom";
import './App.css';
import Footer from 'common/footer'
//import AboutUs from 'pages/about-us'
import Loadable from 'react-loadable'
import LoadingIcon from 'common/loading'

const AboutUs = Loadable({
    loader:()=> import('pages/about-us'),
    loading: LoadingIcon
})

// const FallWinterAward = Loadable({
//     loader:()=> import('pages/fall-winter-award'),
//     loading: LoadingIcon
// })

const ContactUs = Loadable({
    loader:()=> import('pages/contact-us'),
    loading: LoadingIcon
})

const FallWinterGallery = Loadable({
    loader:()=> import('pages/fall-winter-gallery'),
    loading: LoadingIcon
})

const FallWinterWinner = Loadable({
    loader:()=> import('pages/fall-winter-winner'),
    loading: LoadingIcon
})

// const SpringSummerAward = Loadable({
//     loader:() => import('pages/spring-summer-award'),
//     loading: LoadingIcon
// })

const SpringSummerWinner = Loadable({
    loader:() => import('pages/spring-summer-winner'),
    loading: LoadingIcon
})

const SpringSummerGallery = Loadable({
    loader:() => import('pages/spring-summer-gallery'),
    loading: LoadingIcon
})

// const AnnualAward = Loadable({
//     loader:() => import('pages/annual-award'),
//     loading: LoadingIcon
// })

const AnnualWinner = Loadable({
    loader:() => import('pages/annual-winner'),
    loading: LoadingIcon
})

const AnnualGallery = Loadable({
    loader:() => import('pages/annual-gallery'),
    loading: LoadingIcon
})

const HKJapanAwardWinner = Loadable({
    loader:() => import("pages/hk-jp-award-winner"),
    loading: LoadingIcon
})

const AsiaJapanAward = Loadable({
    loader: () => import("pages/asia-jp-award"),
    loading: LoadingIcon
})

const FallWinterJP2022Winner = Loadable({
    loader: () => import("pages/fall-winter-jp-2022-winner"),
    loading: LoadingIcon
})

const FallWinterJP2021Winner = Loadable({
    loader: () => import("pages/fall-winter-jp-2021-winner"),
    loading: LoadingIcon
})

const ILoveDad = Loadable({
    loader: () => import("pages/i-love-dad"),
    loading: LoadingIcon
})
const ILoveDad2023 = Loadable({
    loader: () => import("pages/i-love-dad-2023"),
    loading: LoadingIcon
})

const SprintSummerJP2022 = Loadable({
    loader: () => import("pages/spring-summer-jp-2022-winner"),
    loading: LoadingIcon
})
// const SpringSummerJP2023 = Loadable({
//     loader: () => import("pages/spring-summer-jp-2023"),
//     loading: LoadingIcon
// })

const SpringSummerJP2023Winner = Loadable({
    loader: () => import("pages/spring-summer-jp-2023-winner"),
    loading: LoadingIcon
})

const FallWinterJP2023Winner = Loadable({
    loader: () => import("pages/fall-winter-jp-2023-winner"),
    loading: LoadingIcon
})

const int1 = Loadable({
    loader: () => import("pages/1-int"),
    loading: LoadingIcon
})

// const int2 = Loadable({
//     loader: () => import("pages/2-int"),
//     loading: LoadingIcon
// })
const int2Gallery = Loadable({
    loader: () => import("pages/2-int-gallery"),
    loading: LoadingIcon
})

const int3 = Loadable({
    loader: () => import("pages/3-int"),
    loading: LoadingIcon
})
// const SpringSummerJP2024 = Loadable({
//     loader: () => import("pages/spring-summer-jp-2024"),
//     loading: LoadingIcon
// })
const SpringSummerJP2024Winner = Loadable({
    loader: () => import("pages/spring-summer-jp-2024-winner"),
    loading: LoadingIcon
})
// const FallWinterJP2024 = Loadable({
//     loader: () => import("pages/fall-winter-jp-2024"),
//     loading: LoadingIcon
// })
const FallWinterJP2024Winner = Loadable({
    loader: () => import("pages/fall-winter-jp-2024-winner"),
    loading: LoadingIcon
})
// const SpringSummerJP2025 = Loadable({
//     loader: () => import("pages/spring-summer-jp-2025"),
//     loading: LoadingIcon
// })
const SpringSummerJP2025Winner = Loadable({
    loader: () => import("pages/spring-summer-jp-2025-winner"),
    loading: LoadingIcon
})
// const SpringSummerJP2026 = Loadable({
//     loader: () => import("pages/spring-summer-jp-2026"),
//     loading: LoadingIcon
// })
const FallWinterJP2025Winner = Loadable({
    loader: () => import("pages/fall-winter-jp-2025-winner"),
    loading: LoadingIcon
})
const SpringSummerJP2026Winner = Loadable({
    loader: () => import("pages/spring-summer-jp-2026-winner"),
    loading: LoadingIcon
})
// const FallWinterJP2025 = Loadable({
//     loader: () => import("pages/fall-winter-jp-2025"),
//     loading: LoadingIcon
// })


class App extends Component {
    componentDidMount(){
        const {lang} = this.props.appSettings;
        this.props.fetchLanguage(lang);
    }
    render() {
        return (
            <div className="App">
                <NavBar/>
                <Route path="/about-us" component={AboutUs}/>
                <Route exact path="/" component={SpringSummerJP2026Winner} />
                <Route path="/int1" component={int1} />
                <Route path="/int2" component={int2Gallery} />
                <Route path="/int3" component={int3} />
                <Route path="/fall-winter-jp-2025" component={FallWinterJP2025Winner} />
                <Route path="/spring-summer-jp-2025" component={SpringSummerJP2025Winner} />
                <Route path="/spring-summer-jp-2026" component={SpringSummerJP2026Winner} />

                <Route path="/fall-winter-jp-2024" component={FallWinterJP2024Winner} />
                <Route path="/fall-winter-jp-2022" component={FallWinterJP2022Winner} />
                <Route path="/fall-winter-jp-2023" component={FallWinterJP2023Winner} />
                <Route path="/spring-summer-jp-2024" component={SpringSummerJP2024Winner} />
                <Route path="/spring-summer-jp-2022" component={SprintSummerJP2022} />
                <Route path="/spring-summer-jp-2023" component={SpringSummerJP2023Winner} />
                <Route path="/i-love-dad" component={ILoveDad} />
                <Route path="/i-love-dad-2023" component={ILoveDad2023} />
                <Route path="/asia-jp-award" component={AsiaJapanAward} />
                <Route path="/fall-winter-jp-2021" component={FallWinterJP2021Winner} />
                <Route path="/hk-jp-award" component={HKJapanAwardWinner}/>
                <Route path="/fall-winter-winner" component={FallWinterWinner} />
                <Route path="/fall-winter-gallery" component={FallWinterGallery} />
                <Route path="/spring-summer-winner" component={SpringSummerWinner} />
                <Route path="/spring-summer-gallery" component={SpringSummerGallery} />
                <Route path="/annual-winner" component={AnnualWinner}/>
                <Route path="/annual-gallery" component={AnnualGallery}/>
                <Route path="/contact-us" component={ContactUs} />
                <Footer/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    appSettings: state.app
})

const mapDispatchToProps = {
    fetchLanguage
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js